import { useState } from 'react';

import { useApi } from '../../hooks/useApi';
import logger from '../../utils/logger';

const initialState = {
    email: '',
};

function EmailVerificationRequestForm() {
    const { request, showStatus, setStatus } = useApi();
    const [form, setForm] = useState(initialState);
    const [busy, setBusy] = useState(false);

    const handleSubmit = async (event) => {
        event.preventDefault();

        if (!form.email.trim()) {
            showStatus('error', 'Введите email.');
            return;
        }

        setBusy(true);
        setStatus(null);

        try {
            await request('/api/v1/auth/verify-email/request', {
                method: 'POST',
                body: JSON.stringify(form),
            });
            showStatus('success', 'Если аккаунт существует, письмо с подтверждением отправлено.');
            setForm(initialState);
        } catch (error) {
            logger.error(error);
            showStatus('error', error.message || 'Не удалось отправить письмо подтверждения.');
        } finally {
            setBusy(false);
        }
    };

    return (
        <form className="panel__form" onSubmit={handleSubmit} noValidate>
            <p className="panel__hint">
                Укажите email, чтобы получить новую ссылку подтверждения.
            </p>

            <label>
                Email
                <input
                    type="email"
                    value={form.email}
                    onChange={(event) => setForm({ email: event.target.value })}
                    required
                />
            </label>

            <button type="submit" disabled={busy}>
                Отправить ссылку
            </button>
        </form>
    );
}

export default EmailVerificationRequestForm;
